import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { ListChartCardService } from '../list-chart-card';
import { CmxDashboardOrderHistoryCardService } from './cmx-dashboard-order-history-card.service';
import { Status } from '../list-chart-card';
import { SessionService } from '../../../../../../../angular-services-v8/session.service';
import { SharedFunctions } from '../../../../../../../helpers/functions';

@Component({
  selector: 'cmx-dashboard-order-history-card',
  templateUrl: './cmx-dashboard-order-history-card.component.html',
  styleUrls: ['./cmx-dashboard-order-history-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: ListChartCardService,
      useClass: CmxDashboardOrderHistoryCardService
    }
  ]
})
export class CmxDashboardOrderHistoryCardComponent
  implements OnInit, OnChanges
{
  @Input()
  customerId: string;
  private _date: { from: string; to: string };

  @Input()
  set date(newDate: { from: string; to: string }) {
    this._date = newDate;
  }

  public get date() {
    return this._date
      ? this._date
      : this.isNewDashboard2025Enabled
        ? {
            from: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
            to: new Date(new Date().setHours(23, 59)).toISOString()
          }
        : null;
  }

  @Input()
  title: string;
  @Input()
  dateRanges: Array<{
    label: string;
    from: string; // ISO String
    to: string;
    id: string;
  }>;

  @Input()
  public newDesignTranslation: {
    viewMore: string;
    createOrder: string;
  };

  @Input()
  statusesList: Status[];
  @Input()
  chartTotalLabel = 'Total';
  @Input()
  statusListItemOrdersLabel = 'Orders';
  /**
   * @var emptyListText label to show in the empty result message
   */
  @Input()
  emptyListText;

  /**
   * @var datePlaceholder placeholder for Date range selection
   */
  @Input()
  datePlaceholder: string;

  /**
   * @var extended render also loads progress bar
   */
  @Input()
  extended: boolean;

  /**
   * @var pickerLabelCancel label for cancel button in picker for mobile view
   */
  @Input()
  pickerLabelCancel: string;

  @Input()
  activeJobsiteId: string;

  @Input()
  isNewDashboard2025Enabled: boolean;

  /**
   * @var recentOrdersLabels labels for extended version {title, deliveredLoads, pendingLoads}
   */
  @Input()
  recentOrdersLabels: {
    title: string;
    viewAll: string;
    order: string;
  };

  // Provide a function to update url with region prefix
  // reads from session service the user country code
  // Regions are configured in DCMConstants (DCM.constants.ts)
  constructor(private sessionService: SessionService) {}
  protected _updateUrlRegionPrefix = (url: string): string => SharedFunctions.updateUrlRegionPrefix(url, this.sessionService.userCountry );

  public queryOptions: Record<string, string | number>;
  ngOnInit() {
    if (this.customerId) {
      this.queryOptions = {
        ...this.queryOptions,
        customerId: this.customerId,

        // Data for new design
        ...(this.isNewDashboard2025Enabled && {
          ...(this.date && {
            dateFrom: this.date.from,
            dateTo: this.date.to
          }),

          ...(this.activeJobsiteId &&
            this.activeJobsiteId !== 'ALL' && {
              jobsiteId: this.activeJobsiteId
            })
        })
      };
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('customerId' in changes) {
      const {
        customerId: { currentValue: customerId }
      } = changes;
      if (customerId) {
        this.queryOptions = {
          ...this.queryOptions,
          customerId: this.customerId,

          // Data for new design
          ...(this.isNewDashboard2025Enabled && {
            ...(this.date && {
              dateFrom: this.date.from,
              dateTo: this.date.to
            }),

            ...(this.activeJobsiteId &&
              this.activeJobsiteId !== 'ALL' && {
                jobsiteId: this.activeJobsiteId
              })
          })
        };
      }
    }

    if (this.isNewDashboard2025Enabled) {
      if ('date' in changes) {
        const {
          date: { currentValue: dateRange }
        } = changes;
        if (dateRange) {
          this.queryOptions = {
            ...this.queryOptions,
            dateFrom: dateRange.from,
            dateTo: dateRange.to
          };
        }
      }

      if ('activeJobsiteId' in changes) {
        const {
          activeJobsiteId: { currentValue: jobsiteId }
        } = changes;
        if (jobsiteId) {
          this.queryOptions = {
            ...this.queryOptions,
            jobsiteId: jobsiteId === 'ALL' ? null : jobsiteId
          };
        }
      }
    }
  }
}
